"use strict";
/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI (C) Copyright IBM Corp. 2019, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

var __extends = void 0 && (void 0).__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importStar = void 0 && (void 0).__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var mobx_react_1 = require("mobx-react");

var ca_ui_toolkit_1 = require("ca-ui-toolkit");

var ConditionalPaletteComponent_1 = __importDefault(require("../conditionalPalette/ConditionalPaletteComponent"));

var ConditionalFormatScaleComponent_1 = __importDefault(require("../scale/ConditionalFormatScaleComponent"));

var ColorByComponent_1 = __importDefault(require("../colorBy/ColorByComponent"));

var BackgroundOpacity_1 = __importDefault(require("../backgroundOpacity/BackgroundOpacity"));

var RulesComponent_1 = __importDefault(require("../rules/RulesComponent"));

require("./conditionalColorPanelComponents.scss");

var StringResources_1 = __importDefault(require("../../nls/StringResources"));

var jquery_1 = __importDefault(require("jquery"));

var ConditionalColorPanelComponents =
/** @class */
function (_super) {
  __extends(ConditionalColorPanelComponents, _super);

  function ConditionalColorPanelComponents(props) {
    var _this = _super.call(this, props) || this;

    _this._rulesComponentRef = react_1.default.createRef();
    _this._colorByComponentRef = react_1.default.createRef();
    return _this;
  }

  ConditionalColorPanelComponents.prototype.componentDidUpdate = function () {
    var mstForUIPanels = this.props.mstForUIPanels; // Hack in R7 to just update the Top Banner instead of close/relaunch child panel
    // This is done to prevent UI flashing
    // @todo when Properties Panel/InAppSlideout get converted to remove legacy core-client UI
    // then remove this hack

    if (this.updateTopBannerLabel) {
      if (mstForUIPanels.isChildCFPanel) {
        var $dashboardAuthoringToolsPane = jquery_1.default('.dashboardAuthoringToolsPane');

        if ($dashboardAuthoringToolsPane.length) {
          var $node = $dashboardAuthoringToolsPane.find('.slideout__contributions__item');

          if ($node.data('contribution-id') === 'PropertiesPane' && $node[0].childNodes.length > 1) {
            var $child = jquery_1.default($node[0].childNodes[0]); // Make sure it is a child node

            if ($child.data('child-panel-id')) {
              var replaceBannerString = StringResources_1.default.get('conditionalColor') + ": " + mstForUIPanels.getDataItemLabel();
              $child.attr('aria-label', replaceBannerString);
              $child = $child.find('.propertiesBannerLabel');
              $child.empty().html(replaceBannerString);
            }
          }
        }
      }

      this.updateTopBannerLabel = false;
    }
  };

  ConditionalColorPanelComponents.prototype.componentDidMount = function () {
    var uiContext = this.props.uiContext;
    uiContext.setRulesComponentReactRef(this._rulesComponentRef);
    uiContext.setConditionalColorPanelComponent(this);
  };

  ConditionalColorPanelComponents.prototype.render = function () {
    var _a = this.props,
        uiContext = _a.uiContext,
        mstForUIPanels = _a.mstForUIPanels;
    var currentDataItem = mstForUIPanels.getMeasureDataItem();
    var conditionalFormatModel = mstForUIPanels.getMSTConditionalFormatModel();
    var disabled = mstForUIPanels.isDisabled;
    this.updateTopBannerLabel = this.topBannerLabel && this.topBannerLabel !== mstForUIPanels.getDataItemLabel();
    this.topBannerLabel = mstForUIPanels.getDataItemLabel();
    return (// Two containers are needed here due to a CSS issue with pointer-event overridding cursor styles when on the same element
      react_1.default.createElement(ca_ui_toolkit_1.Container, {
        className: ca_ui_toolkit_1.classnames('vis-cf-panelContainer', {
          disabled: disabled
        })
      }, react_1.default.createElement(ca_ui_toolkit_1.Container, {
        className: ca_ui_toolkit_1.classnames('vis-cf-panelContainer-inner', {
          disabled: disabled
        })
      }, react_1.default.createElement(ConditionalPaletteComponent_1.default, {
        uiContext: uiContext,
        conditionalFormatModel: conditionalFormatModel
      }), !uiContext.isKpiVis() && react_1.default.createElement(ColorByComponent_1.default, {
        ref: this._colorByComponentRef,
        uiContext: uiContext,
        currentDataItem: currentDataItem
      }), react_1.default.createElement(ConditionalFormatScaleComponent_1.default, {
        conditionalFormatModel: conditionalFormatModel
      }), react_1.default.createElement(RulesComponent_1.default, {
        disabled: disabled,
        ref: this._rulesComponentRef,
        conditionalFormatModel: conditionalFormatModel,
        uiContext: uiContext
      }), !uiContext.isKpiVis() && react_1.default.createElement(ca_ui_toolkit_1.Separator, {
        hMargin: 0,
        className: 'vis-cf-background-opacity-separator',
        orientation: 'horizontal'
      }), !uiContext.isKpiVis() && react_1.default.createElement(BackgroundOpacity_1.default, {
        conditionalFormatModel: conditionalFormatModel
      })))
    );
  };

  ConditionalColorPanelComponents.prototype.onSlideoutMounted = function () {
    if (this._colorByComponentRef && this._colorByComponentRef.current) {
      this._colorByComponentRef.current.onSlideoutMounted();
    }
  };

  return ConditionalColorPanelComponents;
}(react_1.Component);

exports.default = mobx_react_1.observer(ConditionalColorPanelComponents);
